import React from 'react';
import { FDAlert, FDStack } from '@facet-wealth/design';
import EligibilityAlertLineItem
  from 'Views/Page/Content/Templates/InvestorProfilePageTemplate/InvestorProfileSections/EligibilityAlertLineItem';
import PropTypes from 'prop-types';
import Resource from 'facet-rest/src/domain/Resource';
import { dataAttrs } from 'Helpers/Testing';

const InvestorEligibilityAlert = ({ resource }) => {
  const metCriteria = resource.attr('eligibilityCriteria') || [];
  const unmetCriteria = resource.attr('unmetEligibilityCriteria') || [];
  return (
    <FDAlert
      title={resource.metaField('isEligible').attr('prompt')}
      status={resource.isTruthy('isEligible') ? 'success' : 'error'}
      description={
        <FDStack direction="column">
          {metCriteria.map((criteriaText) => (
            <EligibilityAlertLineItem key={criteriaText} icon="check" text={criteriaText} />
          ))}
          {unmetCriteria.map((criteriaText) => (
            <EligibilityAlertLineItem key={criteriaText} icon="close" color="warning" text={criteriaText} />
          ))}
        </FDStack>
      }
      {...dataAttrs('investorEligibilityAlert', resource)}
    />
  );
};

InvestorEligibilityAlert.defaultProps = {};

InvestorEligibilityAlert.propTypes = {
  resource: PropTypes.instanceOf(Resource).isRequired,
};

export { InvestorEligibilityAlert };
